import { Button } from "primereact/button";
import { IconUtils } from "primereact/utils";
import React, { useEffect } from "react";
import styles from "./ContactInfo.module.css";

const ContactInfo = () => {
  useEffect(() => {
    const bar = document.getElementById("bar");
    // const menu= document.getElementById('popup_menu_right');
    window.onscroll = function () {
      if (window.pageYOffset > 0 ) {
        bar.style.display = "none";

      } else {
        bar.style.display = "flex";
        // bar.style.height = "100%";
        // bar.style.width = "100%";

        // if (window.innerWidth < 480) {
        //   bar.style.paddingTop = "3vw";
        //   bar.style.paddingBottom = "3vw";
        // }
        // menu.style.display = 'flex';
      }
    };
  }, []);

  return (
    <div className={styles.contactInfoBar} id="bar">
      <div className={styles.socialMedia}>

        <i className={`pi pi-linkedin ${styles.linkedinButton}`}  onClick={() => (window.location.href = "https://www.linkedin.com/company/aulaaba/posts/?feedView=all")}></i>
        <i className={`pi pi-instagram ${styles.instagramButton}`}  onClick={() => (window.location.href = "https://www.instagram.com/aulaaba/")}></i>
        
        {/* <Button
          onClick={() => (window.location.href = "https://www.instagram.com/aulaaba/")}
          icon="pi pi-instagram"
          className={styles.instagramButton}
        /> */}

        <div className={styles.emailContainer}>
          <i className={`pi pi-envelope ${styles.emailButton}`} />
          <span className={styles.emailText}>capacitaciones@aba.org.do</span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
